import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Card, Container } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import { getfollowUpsQueries } from 'src/api/admin';
import { CONSTANTS } from 'src/commons';
import CustomTable from 'src/components/Table';
import Toolbar from 'src/components/member/Toolbar';
import { loaderReducerAction } from 'src/redux/reducers/loader';
import { commonReducerAction } from 'src/redux/reducers/common';

const FollowUpsQueries = () => {
  const dispatch = useDispatch();
  const { startLoading, stopLoading } = loaderReducerAction;
  const { logoutUser } = commonReducerAction;
  const { user, gymId } = useSelector((state) => state.common);
  const [queries, setQueries] = useState([]);
  const [page, setPage] = useState(0);
  const [searchLoader, setSearchLoader] = useState(false);

  useEffect(() => {
    dispatch(startLoading());
    getfollowUpsQueries(user, gymId)
      .then((res) => {
        if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN)
          dispatch(logoutUser());
        if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) setQueries(res.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => dispatch(stopLoading()));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = (_, newPage) => {
    setPage(newPage);
  };

  const onClickRow = () => {};

  const filterItem = (text) => {
    setSearchLoader(true);
    getfollowUpsQueries(user, gymId)
      .then((res) => {
        if (res.status === CONSTANTS.STATUS_CODES.FORBIDDEN)
          dispatch(logoutUser());
        if (res.status === CONSTANTS.STATUS_CODES.SUCCESS) {
          setQueries(
            res.data.filter((member) =>
              member.full_name?.toLowerCase()?.includes(text.toLowerCase())
            )
          );
        }
        setSearchLoader(false);
      })
      .catch((err) => {
        setSearchLoader(false);
        console.log(err);
      });
  };

  return (
    <>
      <Helmet>
        <title>Queries | GMS</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <Toolbar
            searchLoader={searchLoader}
            filterItem={filterItem}
            route={CONSTANTS.ROUTES.PRIVATE_ROUTES.ADD_QUERY}
            text={'Add Query'}
            hideAddButton={true}
            hideFilter={true}
          />
          <Box sx={{ pt: 3 }}>
            <Card>
              <CustomTable
                data={queries}
                dataKeysSequence={['full_name', 'email', 'phone', 'query_date']}
                headers={['Name', 'Email', 'Phone', 'Query Date']}
                handlePageChange={handlePageChange}
                page={page}
                onClickRow={onClickRow}
              />
            </Card>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default FollowUpsQueries;
